export const headingBase = {
  color: "#1e1e1e",
  fontFamily: "'Avenir', sans-serif",
  display: "block",
  marginInlineStart: "0px",
  marginInlineEnd: "0px",
};

export const h1Base = {
  ...headingBase,
  marginBlockStart: "0.67em",
  marginBlockEnd: "0.67em",
  fontWeight: "700",
};

export const h2Base = {
  ...headingBase,
  marginBlockStart: "0.83em",
  marginBlockEnd: "0.83em",
  fontWeight: "700",
};

export const h3Base = {
  ...headingBase,
  marginBlockStart: "1em",
  marginBlockEnd: "1em",
  fontWeight: "600",
};

export const h4 = {
  ...headingBase,
  marginBlockStart: "0.33em",
  marginBlockEnd: "0.33em",
  fontWeight: "bold",
  fontSize: "inherit",
};
